export default __webpack_public_path__ + "static/media/3_carousel.746a7711.jpeg";